import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog"
import { DocumentUploadProgress } from "./document-upload-progress"
import { Button } from "@/components/ui/button"

interface UploadErrorModalProps {
  open: boolean
  onClose: () => void
  filename: string
  stage: 'uploading' | 'processing' | 'embedding' | 'completed' | 'error'
  progress: number
  error?: string
  processingResult?: Record<string, unknown>
}

export function UploadErrorModal({ 
  open, 
  onClose, 
  filename, 
  stage, 
  progress, 
  error, 
  processingResult 
}: UploadErrorModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Estado de Carga</DialogTitle>
          <DialogDescription>
            Progreso de la carga del documento
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <DocumentUploadProgress
            filename={filename}
            stage={stage}
            progress={progress}
            error={error}
            processingResult={processingResult}
          />
          
          <div className="flex justify-end">
            <Button variant="outline" onClick={onClose}>
              Cerrar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
